<template>
    <div>
      <div v-if="show">
        <div class="index-top">
            <h3 class="h3">待办事项</h3>
            <div class="index-t-info">
              <span>{{ user.orders_stay_count }}</span>
              <p>待发货订单</p>
            </div>
            <div class="index-t-info">
              <span>{{ user.profit_stay_convert }}</span>
              <p>绀发订单</p>
            </div>
            <div class="index-t-info">
              <span>{{ user.withdraw_stay_convert }}</span>
              <p>沃隆订单</p>
            </div>
        </div>
        <div class="index-data">
          <h3>快速入口</h3>
          <ul>
            <li>
              <router-link to="/orders">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-dingdan1"></use>
                  </svg>
                </span>
                <p>订单</p>
              </router-link>
            </li>
            <li>
              <router-link to="/data/index">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-lingshouliushuizhangledger"></use>
                  </svg>
                </span>
                <p>码库</p>
              </router-link>
            </li>
            <li>
              <router-link to="/users/index">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-wode"></use>
                  </svg>
                </span>
                <p>我的</p>
              </router-link>
            </li>
            <li>
              <router-link to="/search">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-sousuo"></use>
                  </svg>
                </span>
                <p>防伪查询</p>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="index-data">
        <h3>数据查看</h3>
        <div class="index-d-s">
            <div class="index-d-s-l">
                <span>防伪码总量</span>
                <span class="price">{{ user.sum_count }}</span>
            </div>
            <div class="index-d-s-r">
                <span>剩余防伪码</span>
                <span class="price">{{ user.remain_count }}</span>
            </div>
          <div class="index-d-s-l">
            <span>绀发使用量</span>
            <span class="price">{{ user.gf_count }}</span>
          </div>
          <div class="index-d-s-r">
            <span>沃隆使用量</span>
            <span class="price">{{ user.wl_count }}</span>
          </div>
        </div>
      </div>
      </div>
      <Footer />
      <Laod ref="laoding" />
      <wxNoShare />
    </div>
</template>

<script>
  import { Popup } from 'vant';

  export default {
    components: {
      [Popup.name]: Popup
    },
    name: 'index',
    data() {
      return {
        show: false,
        user: [],
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        this.$api.get('fw/index', null, r=>{
          this.user = r.result
          this.show = true
          this.$refs.laoding.loadClose()
        })
      }
    },
  }
</script>

<style scoped>
  .index-top{
    background: url(../../assets/images/bg_01.jpg) no-repeat;
    background-size: 100%;
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .index-top .h3{
    font-size: 18px;
    color:#fff;
    text-align: center;
    font-weight: normal;
    margin-top: 33px;
    margin-bottom: 35px;
  }
  .index-top .index-t-info{
    color:#fff;
    float: left;
    text-align: center;
    width: 33%;
    padding-bottom: 15px;
  }
  .index-top .index-t-info span{
    font-size: 20px;
  }
  .index-top .index-t-info p{
    font-size: 14px;
    margin-top: 5px;
  }
  .index-data{
    background: #fff;
    overflow: hidden;
    padding:10px;
    margin-bottom:10px;
  }
  .index-data h3{
    color:#323233;
    margin: 0;
    font-size: 15px;
  }
  .index-data ul{
    margin-top: 10px;
  }
  .index-data ul li{
    float: left;
    text-align: center;
    width: 25%;
    padding-bottom: 10px;
  }
  .index-data ul li span{
    font-size: 32px;
  }
  .index-data ul li p{
    margin: 0;
    font-size: 12px;
  }
  .index-data .index-d-s{
    padding:10px 0;
    overflow: hidden;
  }
  .index-data .index-d-s span{
    display: block;
    color:#969799;
    font-size: 14px;
    margin-bottom: 5px;
  }
  .index-data .index-d-s .index-d-s-l{
    width: 40%;
    float: left;
    border-right: 1px solid #DCDEE0;
    margin-left: 8%;
    margin-bottom: 3%;
    margin-top: 2%;
  }
  .index-data .index-d-s .index-d-s-l .price{
    color:#000;
  }
  .index-data .index-d-s .index-d-s-r{
    width: 40%;
    float: right;
    margin-left: 8%;
    margin-bottom: 3%;
    margin-top: 2%;
  }
  .index-data .index-d-s .index-d-s-r .price{
    color:#000;
  }
  .rmg-gz{
    text-align: center;
    margin: 0;
    font-size: 14px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue